<app-frontend-config></app-frontend-config>
<app-accessibility-widget></app-accessibility-widget>
<nz-layout>
  <nz-content>
    <div id="seccionGOV">
      <div class="container">
        <a href="https://www.gov.co" target="_blank" title="Vínculo al sitio web del Gobierno de Colombia">
          <img
            id="logoGOV"
            alt="Escudo de Colombia y logo Gov.co"
            src="{{ assetsBase }}/images/logos/logo_gov_co.png"
          />
        </a>
      </div>
    </div>
    <div class="authContainer">
      <div class="logo-container">
        <img
          [src]="loginLogo || 'assets/fna/images/logos/header-logo.png'"
          (error)="onLoginLogoError()"
          alt="FNA"
          class="logo-img"
        />
      </div>
      <div class="containerInner">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
    <div class="fnaFooter"></div>
  </nz-content>
</nz-layout>
